import { useState } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  phone: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, phone, message }, setState] = useState(initialState);
  const [submitting, setSubmitting] = useState(false);
  const [apiStatus, setApiStatus] = useState(null); // { type: 'success'|'error', message: string }
  const [fieldErrors, setFieldErrors] = useState({}); // { field: message }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  const parseValidation = (exceptions) => {
    const errors = {};
    try {
      if (Array.isArray(exceptions)) {
        exceptions.forEach((ex) => {
          if (ex && Array.isArray(ex.errors)) {
            ex.errors.forEach((err) => {
              const key = (err.propertyname || err.propertypath || "").toLowerCase();
              const message = err.errormessage || err.Message || "Geçersiz değer";
              if (key.includes("dsname") || key.includes("name")) errors.name = message;
              if (key.includes("dsemail") || key.includes("email")) errors.email = message;
              if (key.includes("dsphone") || key.includes("phone")) errors.phone = message;
              if (key.includes("dsmessage") || key.includes("message")) errors.message = message;
            });
          }
        });
      }
    } catch (_) {}
    return errors;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setApiStatus(null);
    setFieldErrors({});

    const payload = {
      dsNameSurname: `TRAssist-${name}`.trim(),
      dsEmail: email,
      dsPhone: phone,
      dsMessage: message,
    };

    try {
      const res = await fetch("https://app.mobilassistance.com/website-service/api/Contact/new-message", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data && data.statu === 200) {
        setApiStatus({ type: "success", message: "Mesajınız başarıyla gönderildi. Müşteri temsilcilerimiz en kısa zamanda sizinle iletişime geçecektir." });
        clearState();
      } else if (data && data.statu === 800) {
        const errs = parseValidation(data.exceptions);
        setFieldErrors(errs);
        setApiStatus({ type: "error", message: "Lütfen formu kontrol edin." });
      } else {
        setApiStatus({ type: "error", message: "Mesaj gönderilirken bir sorun oluştu. Lütfen tekrar deneyin." });
      }
    } catch (error) {
      setApiStatus({ type: "error", message: "Bağlantı hatası. Lütfen daha sonra tekrar deneyin." });
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title text-center">
            <h2>İletişime Geç</h2> 
          </div>
          <div className="row">
            <div className="col-md-4 col-sm-12">
              <div className="contact-form-wrapper">
                {apiStatus && (
                  <div className={`alert ${apiStatus.type === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
                    {apiStatus.message}
                  </div>
                )}
                <form name="sentMessage" noValidate onSubmit={handleSubmit}>
                  <div className={`form-group ${fieldErrors.name ? 'has-error' : ''}`}>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Ad Soyad"
                      required
                      value={name}
                      onChange={handleChange}
                    />
                    {fieldErrors.name && <p className="help-block text-danger">{fieldErrors.name}</p>}
                  </div>
                  
                  <div className={`form-group ${fieldErrors.email ? 'has-error' : ''}`}>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="E-posta"
                      required
                      value={email}
                      onChange={handleChange}
                    />
                    {fieldErrors.email && <p className="help-block text-danger">{fieldErrors.email}</p>}
                  </div>
                  
                  <div className={`form-group ${fieldErrors.phone ? 'has-error' : ''}`}>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-control"
                      placeholder="Telefon"
                      required
                      value={phone}
                      onChange={handleChange}
                    />
                    {fieldErrors.phone && <p className="help-block text-danger">{fieldErrors.phone}</p>}
                  </div>
                  
                  <div className={`form-group ${fieldErrors.message ? 'has-error' : ''}`}>
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Mesajınız"
                      required
                      value={message}
                      onChange={handleChange}
                    ></textarea>
                    {fieldErrors.message && <p className="help-block text-danger">{fieldErrors.message}</p>}
                  </div>
                  
                  <button type="submit" className="btn btn-custom btn-lg btn-block" disabled={submitting}>
                    {submitting ? 'Gönderiliyor...' : 'Mesajı Gönder'}
                  </button>
                </form>
              </div>
            </div>
            
            <div className="col-md-4 col-sm-6">
              <div className="contact-info-wrapper">
                <h3>İletişim Bilgileri</h3>
                <div className="contact-item">
                  <p>
                    <span>
                      <i className="fa fa-map-marker"></i> Adres
                    </span>
                    {props.data ? props.data.address : "loading"}
                  </p>
                </div>
                <div className="contact-item">
                  <p>
                    <span>
                      <i className="fa fa-phone"></i> Telefon
                    </span>
                    {props.data ? props.data.phone : "loading"}
                  </p>
                </div>
                <div className="contact-item">
                  <p>
                    <span>
                      <i className="fa fa-envelope-o"></i> E-posta
                    </span>
                    {props.data ? props.data.email : "loading"}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="col-md-4 col-sm-6">
              <div className="contact-social-wrapper">
                <h3>Sosyal Medya</h3>
                <div className="social-links">
                  <a href={props.data ? props.data.instagram : "/"} target="_blank" rel="noopener noreferrer" className="social-link">
                    <i className="fa fa-instagram"></i>
                    <span>Instagram</span>
                  </a>
                  <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noopener noreferrer" className="social-link">
                    <i className="fa fa-facebook"></i>
                    <span>Facebook</span>
                  </a>
                  <a href={props.data ? props.data.twitter : "/"} target="_blank" rel="noopener noreferrer" className="social-link">
                    <i className="fa fa-twitter"></i>
                    <span>Twitter</span>
                  </a>
                  <a href={props.data ? props.data.youtube : "/"} target="_blank" rel="noopener noreferrer" className="social-link">
                    <i className="fa fa-youtube"></i>
                    <span>YouTube</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Tr Assist Yol Yardım Hizmetleri. Teknoloji Danışmanı:{" "}
            <a href="https://www.mobilinfo.com.tr" rel="nofollow" target="_blank">
              Mobilinfo Bilgi Sistemleri Ltd. Şti.
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
